import type { ApiCall } from "./api";

/** Caller's verified identity as returned by ``GET /v1/me`` (whoami). */
export interface WhoAmI {
  subject: string;
  subject_kind: string;
  scopes: string[];
  realms: string[];
}

/** Fetch the logged-in subject for the identity badge shown in the KW UIs. */
export async function fetchWhoAmI(call: ApiCall): Promise<WhoAmI> {
  return call<WhoAmI>("/me");
}
